import { render, staticRenderFns } from "./SelectedFilters.vue?vue&type=template&id=36e1850d"
import script from "./SelectedFilters.vue?vue&type=script&lang=js"
export * from "./SelectedFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports